import React from 'react';
import styled from 'styled-components/macro';
import { responsive } from '../../resources/constantes.json';
import CustomTooltip from '../../components/CustomTooltip';

const RoundButton = ({
  children = <></>,
  disabled = false,
  onClick = () => {},
  label = undefined,
}) => {
  return (
    <CustomTooltip label={label}>
      <RoundButtonContainer disabled={disabled} onClick={onClick}>
        {children}
      </RoundButtonContainer>
    </CustomTooltip>
  );
};

export const RoundButtonContainer = styled.button`
  align-items: center;
  background: #215ccc;
  border-radius: 100%;
  color: white;
  display: flex;
  justify-content: center;
  height: 50px;
  width: 50px;
  &:hover {
    background: rgb(28, 40, 61, 0.5);
    color: white;
  }
  &:disabled {
    background: dimgrey;
    cursor: not-allowed;
  }

  @media (max-width: ${responsive.maxWidth.tablet}px) {
    &:hover {
      background: #215ccc;
      color: white;
    }
  }

  @media (max-width: ${responsive.maxWidth.mobile}px) {
    height: 35px;
    width: 35px;
  }
`;

export default RoundButton;
